export default "__VITE_ASSET__DGWp1YJR__"